import { Injectable } from '@angular/core';
import { CommentDataEntry } from '@osos/shared/api';
import { CommentPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases/factory/factory-base';
import { CommentParserV1Service } from '../../parsers/comment-parser/comment-parser-v1.service';
import { ParserFactory } from '../../services';

@Injectable()
export class CommentFactoryService extends FactoryBase<
  CommentDataEntry,
  CommentPresenterModel
> {
  constructor(parserFactory: ParserFactory, parseV1: CommentParserV1Service) {
    super(parserFactory);
    parserFactory.register(parseV1);
  }
  createDataModel(presenter: CommentPresenterModel): CommentDataEntry {
    const parser = this.getParser(
      CommentDataEntry,
      CommentPresenterModel,
      presenter.specificationVersion,
    );
    const result = parser.getDataModel(presenter);
    return result;
  }
  createPresenterModel(model: CommentDataEntry | any): CommentPresenterModel {
    const parser = this.getParser(
      CommentDataEntry,
      CommentPresenterModel,
      model.specificationVersion,
    );
    const result = parser?.getPresenterModel(model);
    return result;
  }
}
